import { identityOf, tierOf, type ResolvedIdentity } from './identity';

export interface ConsoleAuthoritySubject {
  role?: string | null;
  displayName?: string | null;
  display_name?: string | null;
}

export interface ConsoleAuthority extends ResolvedIdentity {
  /** UI hint only. The server still authorizes every user-management request. */
  showUserManagement: boolean;
  /** UI hint only for controls backed by requireSuperAdmin server guards. */
  showExecutiveControls: boolean;
}

/**
 * Administration presentation/gating derived only from the backend role.
 * Organizational fields and client-presented tier claims are intentionally not
 * inputs. The returned flags improve UX; they never grant server access.
 */
export function consoleAuthorityOf(subject: ConsoleAuthoritySubject | null | undefined): ConsoleAuthority {
  const tier = tierOf(subject?.role);
  const identity = identityOf({
    role: subject?.role,
    displayName: subject?.displayName ?? subject?.display_name,
  });

  return {
    ...identity,
    showUserManagement: tier === 'SUPER_ADMIN' || tier === 'ADMIN',
    showExecutiveControls: tier === 'SUPER_ADMIN',
  };
}
